import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { configureStore } from "./configureStore";
import { ToastProvider } from "react-toast-notifications";

const rootEl = document.getElementById("root");
const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <ToastProvider>
      <App />
    </ToastProvider>
  </Provider>,
  rootEl
);
